import React from 'react';
import { Card, CardContent } from '../ui/Card';
import { Building2, Clock, CheckCircle, UserCheck } from 'lucide-react';
import { ProfilesCounts } from '../../types';

interface ProfilesStatsProps {
  counts: ProfilesCounts;
  className?: string;
}

export const ProfilesStats: React.FC<ProfilesStatsProps> = ({
  counts,
  className
}) => {
  const stats = [
    {
      label: 'Total Profiles',
      value: counts.total,
      icon: Building2,
      color: 'text-gray-900',
      iconColor: 'text-blue-600'
    },
    {
      label: 'Pending',
      value: counts.pending,
      icon: Clock,
      color: 'text-orange-600',
      iconColor: 'text-orange-600'
    },
    {
      label: 'Processed',
      value: counts.processed,
      icon: CheckCircle,
      color: 'text-green-600',
      iconColor: 'text-green-600'
    },
    {
      label: 'Assigned',
      value: counts.assigned,
      icon: UserCheck,
      color: 'text-purple-600',
      iconColor: 'text-purple-600'
    }
  ];

  return (
    <div className={`grid grid-cols-1 md:grid-cols-4 gap-6 ${className || ''}`}>
      {stats.map((stat) => {
        const IconComponent = stat.icon;
        return (
          <Card key={stat.label}>
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-600 mb-1">{stat.label}</p>
                  <p className={`text-2xl font-bold ${stat.color}`}>{stat.value}</p>
                </div>
                <IconComponent className={`h-8 w-8 ${stat.iconColor}`} />
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};